<template>
    <v-flex>
      <v-list class="hidden-xs-only">
        <v-list-item :two-line="true" v-if="!profile.scrapedProfile.meta.profileNotFound">
          <v-list-item-avatar :size="avatarSize">
            <v-img :src="profile.scrapedProfile.summary.publicProfilePicture"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="display-1 font-weight-light d-flex">
              <span class="name-truncated">{{profile.scrapedProfile.summary.name}}</span>
              <profile-action-buttons :profile="profile" :group="profile.groups[0]"></profile-action-buttons>
            </v-list-item-title>
            <v-list-item-subtitle class="headline font-weight-light	">{{ getPosition }}</v-list-item-subtitle>
          </v-list-item-content>
          <profile-heading-scores-staff :profile="profile" :show-job-offers="showJobOffers" v-if="isStaff"></profile-heading-scores-staff>
          <profile-heading-scores-scouting :profile="profile" :show-job-offers="false" v-else></profile-heading-scores-scouting>

        </v-list-item>
        <v-list-item :two-line="true" v-else>
          <v-list-item-avatar :size="avatarSize">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">{{profile.name}} <v-chip small label color="error">Profile not public</v-chip></v-list-item-title>
            <v-list-item-subtitle class="subtitle-1" v-if="showKeyword">{{profile.keyword}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list class="hidden-sm-and-up">
        <div v-if="!profile.scrapedProfile.meta.profileNotFound">
          <v-list-item :two-line="true" class="pa-0">
            <v-list-item-avatar :size="(avatarSize-15)">
              <v-img :src="profile.scrapedProfile.summary.publicProfilePicture"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline font-weight-light">
                <span class="name-truncated">{{profile.scrapedProfile.summary.name}}</span>
                <profile-action-buttons :profile="profile" :group="profile.groups[0]"></profile-action-buttons>
              </v-list-item-title>
              <v-list-item-subtitle class="headline font-weight-light	">{{ getPosition }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pa-0">
            <profile-heading-scores-staff :profile="profile" :show-job-offers="showJobOffers" v-if="isStaff"></profile-heading-scores-staff>
            <profile-heading-scores-scouting :profile="profile" :show-job-offers="false" v-else></profile-heading-scores-scouting>
          </v-list-item>
        </div>
        <v-list-item :two-line="true" v-else class="pa-0">
          <v-list-item-avatar :size="avatarSize">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">{{profile.name}} <v-chip small label color="error">Profile not public</v-chip></v-list-item-title>
            <v-list-item-subtitle class="subtitle-1" v-if="showKeyword">{{profile.keyword}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-flex>
</template>

<script>
    import ProfileActionButtons from "./profileActionButtons";
    import EditProfile from "../Buttons/Profiles/editProfile";
    import {mapEngagementColor} from "../../helpers/helpers";
    import ProfileHeadingScoresStaff from "./profileHeadingScoresStaff";
    import ProfileHeadingScoresScouting from "./profileHeadingScoresScouting";
    export default {
        name: "profileHeading",
        components: {ProfileHeadingScoresScouting, ProfileHeadingScoresStaff, EditProfile, ProfileActionButtons},
        props: ['profile', 'showKeyword', 'avatarSize', 'showJobOffers'],
        computed: {
          getPosition() {
            return this.profile && this.profile.jobSearchTerms.length > 0 && this.profile.jobSearchTerms[0].jobKeywordName ? this.profile.jobSearchTerms[0].jobKeywordName : this.profile.keyword;
          },
          isStaff(){
            return this.profile && this.profile.groups.indexOf('staff') > -1;
          }
        }
    }
</script>

<style scoped>
.name-truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/profileHeading.vue